module.exports = __webpack_public_path__ + "52d84b87ea5cd08a6488c47492e6c230.svg";